module.exports = __webpack_public_path__ + "img/smart-watch.0f6d5704.webp";